import FooterBar from './footer-bar.vue'
export default FooterBar



// WEBPACK FOOTER //
// ./src/components/main/components/footer-bar/index.js